/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import Reports from '../../modules/Reports/Reports'
import {useIntl} from 'react-intl'

const DashboardPage: FC = () => {
  useEffect(() => {
    document.body.setAttribute('data-kt-app-sidebar-minimize', 'on')
    return () => {
      document.body.removeAttribute('data-kt-app-sidebar-minimize')
    }
  }, [])

  return <Reports />
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
